<template>
	<div class="mines" :style="{backgroundImage: isMob ? null : 'url(/assets/boomx/images/mines-bg.jpg)'}">
		<div class="mines__steps">
			<div class="game-step no-scrollbar" ref="steps">
				<swiper class="game-step__slider"
					:slides-per-view="'auto'"
					:space-between="12"
					@swiper="onSwiper"
					:grab-cursor="true"
					:key="bet"
				>
					<template v-for="(totalMines, key) in mines[bomb - 2]">
						<swiper-slide class="game-step__slide" v-for="(mine, counter) in totalMines">
							<div class="game-step__item" :class="[(game.active_path === ((key * 2) + (counter + 1)) && game.win && !changeBombs) ? 'active' : '', (((key * 2) + (counter + 1)) < game.active_path && !changeBombs) ? 'success' : '', (game.active_path === ((key * 2) + (counter + 1)) && !game.win && !changeBombs) ? 'danger' : '']">
								<div class="game-step__item-num">{{ (key * 2) + (counter + 1) }}</div>
								<div class="game-step__item-body">
									<div class="game-step__item-title">{{ (bet * mine).toFixed(2) }}</div>
									<div class="game-step__item-text">x{{ mine }}</div>
								</div>
							</div>
						</swiper-slide>
					</template>
				</swiper>
			</div>
		</div>
		<div class="mines__grid" :class="[!game.active ? 'disabled' : '']">
			<div class="mines__row" v-for="blockKey in 5">
				<template v-for="bombKey in 5">
					<div class="mines__cell" v-if=" game.bombs[setCounterBombKeys(`${blockKey}_${bombKey}`)] === false && typeof game.selected_bombs[setCounterBombKeys(`${blockKey}_${bombKey}`)] === 'undefined'">
						<svg class="mines__gift">
							<use href="#svg-icon-mines-gift"></use>
						</svg>
					</div>

					<div class="mines__cell" v-else-if="game.bombs[setCounterBombKeys(`${blockKey}_${bombKey}`)] === true && typeof game.selected_bombs[setCounterBombKeys(`${blockKey}_${bombKey}`)] === 'undefined'">
						<svg class="mines__bomb">
							<use href="#svg-icon-bomb"></use>
						</svg>
					</div>

					<button type="button" :disabled="!game.active" class="mines__cell mines-sq" v-else-if="typeof game.selected_bombs[setCounterBombKeys(`${blockKey}_${bombKey}`)] === 'undefined'" @click="setBomb(setCounterBombKeys(`${blockKey}_${bombKey}`))">
						<div v-if="loadBomb === setCounterBombKeys(`${blockKey}_${bombKey}`)" role="status" style="color:#dbe0e9" class="spinner-grow-sm spinner-grow">
							<span class="sr-only"></span>
						</div>
						<div class="mines__cell-num" v-else>{{bombKey + ((blockKey - 1) * 5)}}</div>
					</button>

					<div class="mines__cell active" v-else-if="game.selected_bombs[setCounterBombKeys(`${blockKey}_${bombKey}`)] === false">
						<svg class="mines__gift">
							<use href="#svg-icon-mines-gift"></use>
						</svg>
					</div>

					<div class="mines__cell active" v-else-if="game.selected_bombs[setCounterBombKeys(`${blockKey}_${bombKey}`)] === true">
						<svg class="mines__bomb">
							<use href="#svg-icon-bomb"></use>
						</svg>
					</div>
				</template>
			</div>
		</div>

		<div class="mines__controls" :class="[game.active ? 'disabled' : '']">
			<div class="mines__control game-controls">
				<button class="game-controls__item" @click="typeBet('min')" type="button">Мин</button>
				<button class="game-controls__item" @click="typeBet('/2')" type="button">÷2</button>
				<div class="game-controls__bet">
					<div class="game-controls__bet-value">
						<div class="game-controls__bet-value-wrap">
							<div class="game-controls__bet-value-plug">{{bet}}</div>
							<input class="game-controls__bet-value-input"
								 	id="minesAmount"
									type="number"
									v-model="bet"
									@keyup="validateBet"
									autocomplete="off"
								 :disabled="(game.active || disableBtn)"
							>
						</div>₽
					</div>
					<div class="game-controls__bet-label">Ставка</div>
				</div>
				<button class="game-controls__item" @click="typeBet('x2')" type="button">×2</button>
				<button class="game-controls__item" @click="typeBet('max')" type="button">Макс</button>
			</div>

			<div class="mines__control game-controls">
				<button class="game-controls__item" @click="setBombCount('min')" type="button">Мин</button>
				<button class="game-controls__item" @click="setBombCount('/2')" type="button">÷2</button>
				<div class="game-controls__bet">
					<div class="game-controls__bet-value">
						<div class="game-controls__bet-value-wrap">
							<div class="game-controls__bet-value-plug">{{bomb}}</div>
							<input class="game-controls__bet-value-input"
										 id="minesAmount"
										 type="number"
										 v-model="bomb"
										 autocomplete="off"
										 @change="validateBombCount"
										 :disabled="(game.active || disableBtn)"
							>
						</div>
					</div>
					<div class="game-controls__bet-label">Бомбы</div>
				</div>
				<button class="game-controls__item" @click="setBombCount('x2')" type="button">×2</button>
				<button class="game-controls__item" @click="setBombCount('max')" type="button">Макс</button>
			</div>
		</div>

		<div class="mines__buttons">
			<div class="mines__button" v-if="!game.active">
				<button @click="startGameSocket" v-if="!game.active" class="btn btn--block btn--lg" style="">Играть</button>
			</div>

			<div class="mines__button" v-if="game.active && game.active_path <= 1">
				<button class="btn btn--block disabled" disabled @click="typeBet('min')"> Выберите ячейку </button>
			</div>

			<div class="mines__button" v-if="game.active_path > 1 && game.win && !cashingOut">
				<button class="btn btn--block btn--success"
								:class="[(loadBomb > 0 || disableBtnCashout) ? 'disabled': '']"
								@click="cashOut">
					Забрать {{ $root.currency((bet * getActiveCoef()).toFixed(2)) }}
				</button>
			</div>

			<div class="mines__button" v-if="game.active && !cashingOut">
				<button class="btn btn--block"
								:class="[(loadBomb > 0 || disableBtnCashout) ? 'disabled': '']"
								@click="autoSelect">
					Авто
				</button>
			</div>

			<div v-if="notification.success"
					 style="pointer-events:none;box-shadow: 0 5px 23px 0 rgba(0, 215, 126, 0.27);"
					 class="btn btn--success btn--block mines__button">
				{{ notification.success }}
			</div>

			<div v-if="notification.error"
					 style="pointer-events:none; box-shadow: 0 5px 23px 0 rgba(255, 105, 114, 0.14);" class="btn btn--block bg-danger mines__button">
				{{ notification.error }}
			</div>
		</div>
	</div>
</template>

<script>

	import breakpointsMixin from "../../mixins/breakpoints-mixin.vue";
	import { mapState } from 'pinia';
	import { useUserStore } from '../../stores/User';
	import { Swiper, SwiperSlide } from 'swiper/vue';

    export default {

		components: {
			Swiper,
			SwiperSlide,
		},

		mixins: [
			breakpointsMixin
		],

        data() {
            return {
                bet: 1,
                bomb: 3,
                mines: [
                    [[1.01, 1.08], [1.18, 1.30], [1.44, 1.59], [1.78, 2.01], [2.27, 2.60], [3, 3.50], [4.14, 4.96], [6.07, 7.58], [9.75, 13], [18.20, 27.30], [45.50, 91], [273]],
                    [[1.04, 1.18], [1.36, 1.57], [1.84, 2.16], [2.57, 3.08], [3.74, 4.60], [5.75, 7.32], [9.51, 12.69], [17.44, 24.92], [37.37, 59.80], [104.65, 209.3], [523.25, 2093]],
                    [[1.08, 1.30], [1.57, 1.92], [2.38, 2.97], [3.76, 4.84], [6.32, 8.44], [11.50, 16.10], [23.26, 34.88], [54.82, 91.36], [164.45, 328.9], [767.43, 2302.30], [11511.50]],
                    [[1.14, 1.44], [1.84, 2.38], [3.12, 4.16], [5.64, 7.82], [11.07, 16.10], [24.15, 37.56], [61.04, 104.65], [191.86, 383.72], [863.36, 2302.3], [8058.05, 48348.30]],
                    [[1.20, 1.59], [2.16, 2.97], [4.16, 5.94], [8.68, 13.02], [20.13, 32.20], [53.66, 93.92], [174.42, 348.83], [767.43, 1918.58], [5755.75, 23023], [161161]],
                    [[1.26, 1.78], [2.57, 3.76], [5.64, 8.68], [13.74, 22.50], [38.24, 67.98], [127.45, 254.92], [552.32, 1325.57], [3645.31, 12151.03], [54679.62, 437437]],
                    [[1.34, 2.01], [3.08, 4.84], [7.82, 13.02], [22.50, 40.49], [76.48, 152.95], [327.75, 764.75], [1988.35, 5965.05], [21871.85, 109359.25], [984233.25]],
                    [[1.42, 2.27], [3.74, 6.32], [11.07, 20.13], [38.24, 76.48], [162.51, 371.45], [928.63, 2600.15], [8450.49, 33801.95], [185910.73, 1859107.25]],
                    [[1.52, 2.60], [4.60, 8.44], [16.10, 32.20], [67.98, 152.95], [371.45, 990.54], [2971.60, 10400.60], [45069.27, 270415.60], [2974571.60]],
                    [[1.63, 3], [5.75, 11.50], [24.15, 53.66], [127.45, 327.75], [928.63, 2971.6], [11143.5, 52003], [338019.50, 4056234]],
                    [[1.75, 3.50], [7.32, 16.10], [37.56, 93.92], [254.92, 764.75], [2600.15, 10400.60], [52003, 364021], [4732273]],
                    [[1.89, 4.14], [9.51, 23.26], [61.04, 174.42], [552.32, 1988.35], [8450.49, 45069.27], [338019.50, 4732273]],
                    [[2.07, 4.96], [12.69, 34.88], [104.65, 348.83], [1325.57, 5965.05], [33801.95, 270415.60], [4056234]],
                    [[2.27, 6.07], [17.44, 54.82], [191.86, 767.43], [3645.31, 21871.85], [185910.73, 2974571.60]],
                    [[2.53, 7.58], [24.92, 91.36], [383.72, 1918.58], [12151.03, 109359.25], [1859107.25]],
                    [[2.84, 9.75], [37.37, 164.45], [863.36, 5755.75], [54679.62, 984233.25]],
                    [[3.25, 13], [59.8, 328.9], [2302.3, 23023], [437437]],
                    [[3.79, 18.20], [104.65, 767.43], [8058.05, 161161]],
                    [[4.55, 27.30], [209.30, 2302.30], [48348.30]],
                    [[5.69, 45.5], [523.25, 11511.50]],
                    [[7.58, 91], [2093]],
                    [[11.38, 273]],
                    [[22.75]]
                ],
                notification: {},
                disableBtn: false,
                cashingOut: false,
                game: {
                    active: false,
                    selected_bombs: [],
                    active_path: 0,
                    bombs: [],
                    win: true
                },
                counterBombsBlock: [],
                counterBombs: 0,
                disableBtnBomb: false,
                loadBomb: 0,
                lastLoseGame: {
                    active: false,
                    id: 0
                },
                changeBombs: false,
                disableBtnCashout: false,
				swiper: null
            }
        },
        mounted() {
            //this.$root.isLoading = true;

            if (this.$cookie.get('token')) {
                this.getGame();
            } else {
                this.$root.isLoading = false;
            }
        },

		watch: {
			['game.active_path']() {
				this.scrollToActiveStep();
			}
		},

		computed: {
			...mapState(useUserStore, ['user']),
		},

        methods: {
            autoSelect() {
				let notActive = this.$el.querySelectorAll('.mines-sq')
                notActive[Math.floor(Math.random()*notActive.length)].click()
            },
            validateBet() {
                if (this.bet > 1000000) {
                    this.bet = 1000000;
                }

				if (this.user && this.user.balance < this.bet) {
					this.bet = this.user.balance;
				}

                this.changeBombs = true;
                this.bet = this.bet.toString();
                this.bet = this.bet.replace(/[,]/g, '.').replace(/[^\d,.]*/g, '').replace(/([,.])[,.]+/g, '$1').replace(/^[^\d]*(\d+([.,]\d{0,2})?).*$/g, '$1');
            },
            getMinesRate() {
                if (this.bet > 1000000) {
                    this.bet = 1000000;
                }

				if (this.user && this.user.balance < this.bet) {
					this.bet = this.user.balance;
				}
                this.changeBombs = true;
            },

			async scrollToActiveStep() {
				setTimeout(() => {
					this.swiper.slideTo(this.game.active_path - 2);
				},1)

			},

			onSwiper(inst) {
				this.swiper = inst;
			},

            typeBet(type) {
                switch (type) {
                    case "max":
                        if (this.user !== null) {
                            this.bet = this.user.balance;
                        } else {
                            this.bet = 0;
                        }
                        break;
                    case "min":
                        this.bet = 1;
                        break;
                    case "x2":
						this.bet = this?.user?.balance && this.bet * 2 > +this.user.balance ? this.user.balance : (this.bet * 2).toFixed(2);
                        break;
                    case "/2":
                        this.bet = (this.bet / 2).toFixed(2);
                        break;
                }

                this.validateBet();
            },

			setBombCount(type){
					switch (type) {
							case "max":
								this.bomb = 24;
								break;
							case "min":
								this.bomb = 2;
								break;
							case "x2":
								this.bomb = this.bomb * 2 < 24 ? this.bomb * 2 : 24;
								break;
							case "/2":
								this.bomb = this.bomb / 2 > 2 ? this.bomb / 2 : 2;
								break;
					}
					this.getMinesRate();
			},

			validateBombCount() {
				if (this.bomb > 24) {
					this.bomb = 24
				}

				if (this.bomb < 2) {
					this.bomb = 2;
				}
				this.getMinesRate();
			},

            startGameSocket() {
                if (this.disableBtn || this.game.active) {
                    return;
                }

                this.notification = {};
                this.disableBtn = true;
                this.disableBtnBomb = false;
                this.disableBtnCashout = false;

                if (!this.$cookie.get('token')) {
                    this.notification.error = 'Авторизуйтесь';

                    this.disableBtn = false;

                    return;
                }

                if (this.bet.length === 0) {
                    this.notification.error = 'Введите ставку';

                    this.disableBtn = false;

                    return;
                }

                if (this.bomb.length === 0) {
                    this.notification.error = 'Укажите кол-во бомб';

                    this.disableBtn = false;

                    return;
                }
                this.$root.axios.post('/api/game/mines/start', {
                    mines: this.bomb,
                    bet: this.bet
                }).then(res => {
                    const data = res.data;

                    this.user.balance = data.balance;
                    this.lastLoseGame.active = false;

                    this.game = {
                        active: true,
                        selected_bombs: [],
                        active_path: 1,
                        bombs: [],
                        win: true
                    };

                    this.changeBombs = false;
                }).catch(error => {
                    this.notification.error = this.$root.graphql.axiosGetError(error);
                });
            },
            setBomb(bomb) {
                if (this.disableBtnBomb) {
                    return;
                }

                this.loadBomb = bomb;
                this.disableBtnBomb = true;
                this.notification = {};

                this.$root.axios.post('/api/game/mines/step', {
                    position: bomb
                }).then(res => {
                    const data = res.data;
                    const selectedBombs = data.selected_bombs;

                    this.game.selected_bombs = selectedBombs;
                    this.loadBomb = 0;

                    if (data.win) {
                        this.game.active_path = Object.keys(selectedBombs).length + 1;

                        if (data.insta_win) {
                            this.user.balance += data.amount;
                            this.endGame(data.history);
                        } else {
                            this.disableBtnBomb = false;
                        }
                    } else {
                        this.game.bombs = data.bombs;
                        this.game.win = false;
                        this.game.active = false;

                        this.lastLoseGame = {
                            active: true,
                            id: data.id
                        };

                        // this.addMyHistory(data.history);

                        this.disableBtn = false;
                    }
                }).catch(error => {
                    this.notification.error = this.$root.graphql.axiosGetError(error);
                });
            },
            setCounterBombKeys(key) {
                if (typeof this.counterBombsBlock[key] === 'undefined') {
                    this.counterBombs++

                    this.counterBombsBlock[key] = this.counterBombs;

                    return this.counterBombsBlock[key];
                } else {
                    return this.counterBombsBlock[key];
                }
            },
            getActiveCoef() {
                let index = 0;
                if ((this.game.active_path - 1) % 2 === 0) index = 1;

                return this.mines[this.bomb - 2][Math.floor((this.game.active_path) / 2) - 1][index];
            },
            cashOut() {
                if (this.disableBtnCashout || this.cashingOut) {
                    return;
                }

                this.notification = {};
                this.disableBtnCashout = true;
                this.cashingOut = true;

                this.$root.axios.post('/api/game/mines/take').then(res => {
                    const data = res.data;

                    this.user.balance += data.amount;

                    this.endGame();
                }).catch(error => {
                    this.notification.error = this.$root.graphql.axiosGetError(error);
                });

                this.disableBtnCashout = false;
                this.cashingOut = false;
            },
            endGame(game) {
                this.notification = {};
                this.disableBtn = false;
                this.game = {
                    active: false,
                    selected_bombs: [],
                    active_path: 0,
                    bombs: [],
                    win: true
                }
                this.counterBombsBlock = [];
                this.counterBombs = 0;
                this.disableBtnBomb = false;
                this.loadBomb = 0;
                this.lastLoseGame = {
                    active: false,
                    id: 0
                };
                this.changeBombs = false;
                // this.addMyHistory(game);
				this.scrollToActiveStep();
            },
            getGame() {
                this.$root.graphql.getMinesGame().then(res => {
                    const game = res;

                    if (game.success) {
                        this.disableBtn = true;
                        this.lastLoseGame.active = false;
                        this.changeBombs = false;

                        this.bet = game.bet;
                        this.bomb = game.bomb;

                        // $(".js-range-slider").data('ionRangeSlider').update({from: this.bomb});

                        this.game = {
                            active: true,
                            selected_bombs: game.selected_bombs,
                            active_path: game.active_path,
                            bombs: [],
                            win: true
                        }
                    }

                    this.$root.isLoading = false;
                }).catch(error => {
                    this.notification.error = this.$root.graphql.getError(error);
                });
            }
        }
    }
</script>